import RouterUtils from "../../../../../shared/routing/RouterUtils";
import {ApiEndpoints} from '../../../../../shared/webservices/endpoint';
import GenericRequest, {METHOD_POST} from '../../../../../shared/webservices/GenericRequest';

export class SendCompanyMachineMissingInfoEmailTask extends GenericRequest {

    _request; // SendCompanyMachineMissingInfoEmailRequest

    constructor(id) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.SEND_COMPANY_MACHINE_MISSING_INFO_EMAIL, { id }));
        this._request = {};
    }

    overrideRequest() {
        return this._request;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/sendMissingInfoEmail/ws/SendCompanyMachineMissingInfoEmailTask.js